module.exports = __webpack_public_path__ + "assets/img/banner.b982d371.png";